import cn from 'classnames';
import Link from 'next/link';
import { FC } from 'react';

import Schedules from '~components/Billboard/Schedules';
import Poster from '~components/ui/Poster';
import { NormalizedMovie } from '~utils/normalizers/normalizeCinemaMovie';

import { Attachment, Show } from '~types';

import s from './CinemaMovie.module.css';

interface Props {
  movie: NormalizedMovie;
  cinemaTimezone: string;
}

const CinemaMovie: FC<Props> = ({ movie, cinemaTimezone }) => {
  return (
    <div className={s.root}>
      <div className={s.details}>
        <Link href={`/pelicula/${movie.slug}`} className={s.main}>
          <Poster data={movie.poster as Attachment} />
        </Link>
      </div>
      <div className={s.schedules}>
        <p>
          <Link prefetch={false} href={`/pelicula/${movie.slug}`} className={cn(s.title, 'block')}>
            {movie.title}
          </Link>
          {movie.originalTitle && <span className={s.originalTitle}>{movie.originalTitle}</span>}
        </p>
        <Schedules
          shows={movie.Shows as Show[]}
          movieSlug={movie?.slug as string}
          timezone={cinemaTimezone}
          theme={'default'}
          movieTitle={movie?.title}
        />
      </div>
    </div>
  );
};

export default CinemaMovie;
